import { fetchChatList, fetchMessengerChatList, fetchUnreadNotificationCount } from "./fetch"

export function applyNotificationDots(accessToken: string) {
    applyStarsChatNotificationDot(accessToken)
    applyUserNotificationDot(accessToken)
    applyMessengerNotificationDot(accessToken)
}

async function applyStarsChatNotificationDot(accessToken: string) {
    const result = await fetchChatList(accessToken)
    const menuElement = document.getElementById("chat_menu_dot")
    const loginMenuChatDot = document.getElementById("notification-login-menu-dot")
    let count = 0
    for (let i = 0; i < result.length; i++) {
        count += result[i].newMessageCount

        if (count >= 10) {
            if (menuElement !== null) {
                menuElement.classList.add("profile-modal-navbar-dot")
                menuElement.innerHTML = "9+"
            }
            if (loginMenuChatDot !== null) {
                loginMenuChatDot.classList.add("notification-dot")
            }
            break
        }
    }

    if (count > 0 && count < 10) {
        if (menuElement !== null) {
            menuElement.classList.add("profile-modal-navbar-dot")
            menuElement.innerHTML = String(count)
        }
        if (loginMenuChatDot !== null) {
            loginMenuChatDot.classList.add("notification-dot")
        }
    }
}

async function applyUserNotificationDot(accessToken: string) {
    const result = await fetchUnreadNotificationCount(accessToken)
    const menuElement = document.getElementById("notification_menu_dot")
    const loginMenuNotificationDot = document.getElementById("notification-login-menu-dot")

    if (result.unreadCount >= 10) {
        if (menuElement !== null) {
            menuElement.classList.add("profile-modal-navbar-dot")
            menuElement.innerHTML = "9+"
        }
        if (loginMenuNotificationDot !== null) {
            loginMenuNotificationDot.classList.add("notification-dot")
        }
    }

    if (result.unreadCount > 0 && result.unreadCount < 10) {
        if (menuElement !== null) {
            menuElement.classList.add("profile-modal-navbar-dot")
            menuElement.innerHTML = String(result.unreadCount)
        }
        if (loginMenuNotificationDot !== null) {
            loginMenuNotificationDot.classList.add("notification-dot")
        }
    }
}

async function applyMessengerNotificationDot(accessToken: string) {
    const result = await fetchMessengerChatList(accessToken)

    if (!result.content) {
        return
    }

    const menuElement = document.getElementById("ladies_chat_menu_dot")
    const loginMenuNotificationDot = document.getElementById("notification-login-menu-dot")

    let count = 0
    for (let i = 0; i < result.content.length; i++) {
        count += result.content[i].newMessageCount
        if (count >= 10) {
            if (menuElement !== null) {
                menuElement.classList.add("profile-modal-navbar-dot")
                menuElement.innerHTML = "9+"
            }

            if (loginMenuNotificationDot !== null) {
                loginMenuNotificationDot.classList.add("notification-dot")
            }
            break
        }
    }

    if (count > 0 && count < 10) {
        if (menuElement !== null) {
            menuElement.classList.add("profile-modal-navbar-dot")
            menuElement.innerHTML = String(count)
        }

        if (loginMenuNotificationDot !== null) {
            loginMenuNotificationDot.classList.add("notification-dot")
        }
    }
}
